export const SECS_IN_DAY = 24 * 60 * 60;
export const SECS_IN_HOUR = 60 * 60;
export const SECS_IN_MINUTE = 60;
